<div>
    <br />
    <hr />
    <br />
    <div *ngIf="orderIssues">
        <div *ngIf="ordersWithProductionIssues">
            <div class="row">
                <div class="col">
                    <h2>Potentiella produktionsproblem ({{ordersWithProductionIssues}})</h2>
                </div>
                <div class="col align-right">

                </div>
            </div>

            <table class="fullwidth styled">
                <tr>
                    <th>#</th>
                    <th>{{ 'Produkter' | translate }}</th>
                    <th>{{ 'Skapad' | translate }}</th>
                    <th>{{ 'Skickad till print' | translate }}</th>
                    <th>{{ 'Skickad' | translate }}</th>
                    <th>{{ 'Producent' | translate }}</th>
                    <th>{{ 'Produktion bekräftad' | translate }}</th>
                    <th>{{ 'Produktionstid' | translate }}</th>
                    <th>{{ 'Total leveranstid hittills' | translate }}</th>
                    <th></th>
                    <th></th>
                </tr>
                <tr *ngFor="let order of productionIssueOrders">
                    <td>
                        {{order.orderNumber}}
                        <div class="partner-store-admin-color small-text"
                            *ngIf="globals.userIsAce && order.thirdParty && order.thirdParty.texPrint && order.thirdParty.texPrint.order">
                            (Texprint: {{order.thirdParty.texPrint.order.id}})
                        </div>
                    </td>
                    <td>
                        <div *ngFor="let item of order.items">{{item.sku}}</div>
                    </td>
                    <td>{{order.created | date : 'yyyy-MM-dd HH:mm'}}</td>
                    <td>
                        <ng-container *ngIf="order.metadata && order.metadata.queuedForPrintDate">
                            {{order.metadata.queuedForPrintDate | date : 'yyyy-MM-dd HH:mm'}}
                        </ng-container>
                        <ng-container *ngIf="!order.metadata || !order.metadata.queuedForPrintDate">
                            -
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngIf="order.metadata && order.metadata.dispatchDate">
                            {{order.metadata.dispatchDate | date : 'yyyy-MM-dd HH:mm'}}
                        </ng-container>
                        <ng-container *ngIf="!order.metadata || !order.metadata.dispatchDate">
                            -
                        </ng-container>
                    </td>
                    <td>{{getOrderFulfillmentPartners(order)}}</td>
                    <td>
                        <ng-container *ngFor="let confirmation of getOrderProductionConfirmations(order)">
                            <div *ngIf="confirmation">{{confirmation}}</div>
                            <div class="negative-color material-symbols-outlined" *ngIf="!confirmation">close</div>
                        </ng-container>
                    </td>
                    <td>{{getOrderProductionDays(order)}}</td>
                    <td>{{getOrderTotalDeliveryDays(order)}}</td>
                    <td>
                        <ng-container *ngIf="order.shippingDispatches">
                            <ng-container *ngFor="let dispatch of order.shippingDispatches">
                                <a href="{{dispatch.trackingUrl}}" target="_blank"><span
                                        [ngClass]="{'delivered': dispatch.delivered, 'returned': dispatch.returned}"
                                        class="material-symbols-outlined partner-color shipping-icon">local_shipping</span></a>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <button mat-raised-button color="primary" (click)="markOrderAsDelivered(order)">{{ 'Levererad' | translate }}</button>
                    </td>
                </tr>
            </table>

        </div>
        <div class="row" *ngIf="!ordersWithProductionIssues">
            <div class="col-12">
                <h2>{{ 'Inga produktionsproblem upptäcktes.' | translate }}</h2>
            </div>
            <div class="col-12 align-right">
                <mat-checkbox [(ngModel)]="showSentOrderIssues" (change)="showSentOrderIssuesChanged()"
                    color="primary">{{ 'Inkludera skickade(men ej levererade) ordrar' | translate }}</mat-checkbox>
            </div>
        </div>
        <br />
        <hr />
        <br />

        <div *ngIf="ordersWithDeliveryIssues">
            <div class="row">
                <div class="col">
                    <h2>Potentiella leveransproblem ({{ordersWithDeliveryIssues}})</h2>
                </div>
                <div class="col align-right">
                    <mat-checkbox [(ngModel)]="showSentOrderIssues" (change)="showSentOrderIssuesChanged()"
                        color="primary">{{ 'Inkludera skickade(men ej levererade) ordrar' | translate }}</mat-checkbox>
                </div>
            </div>

            <table class="fullwidth styled">
                <tr>
                    <th>#</th>
                    <th>{{ 'Produkter' | translate }}</th>
                    <th>{{ 'Skapad' | translate }}</th>
                    <th>{{ 'Skickad till print' | translate }}</th>
                    <th>{{ 'Skickad' | translate }}</th>
                    <th>{{ 'Producent' | translate }}</th>
                    <th>{{ 'Produktion bekräftad' | translate }}</th>
                    <th>{{ 'Produktionstid' | translate }}</th>
                    <th>{{ 'Total leveranstid hittills' | translate }}</th>
                    <th></th>
                    <th></th>
                </tr>
                <tr *ngFor="let order of overdueOrders">
                    <td>
                        {{order.orderNumber}}
                        <div class="partner-store-admin-color small-text"
                            *ngIf="globals.userIsAce && order.thirdParty && order.thirdParty.texPrint && order.thirdParty.texPrint.order">
                            (Texprint: {{order.thirdParty.texPrint.order.id}})
                        </div>
                    </td>
                    <td>
                        <div *ngFor="let item of order.items">{{item.sku}}</div>
                    </td>
                    <td>{{order.created | date : 'yyyy-MM-dd HH:mm'}}</td>
                    <td>
                        <ng-container *ngIf="order.metadata && order.metadata.queuedForPrintDate">
                            {{order.metadata.queuedForPrintDate | date : 'yyyy-MM-dd HH:mm'}}
                        </ng-container>
                        <ng-container *ngIf="!order.metadata || !order.metadata.queuedForPrintDate">
                            -
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngIf="order.metadata && order.metadata.dispatchDate">
                            {{order.metadata.dispatchDate | date : 'yyyy-MM-dd HH:mm'}}
                        </ng-container>
                        <ng-container *ngIf="!order.metadata || !order.metadata.dispatchDate">
                            -
                        </ng-container>
                    </td>
                    <td>{{getOrderFulfillmentPartners(order)}}</td>
                    <td>
                        <ng-container *ngFor="let confirmation of getOrderProductionConfirmations(order)">
                            <div *ngIf="confirmation">{{confirmation}}</div>
                            <div class="negative-color material-symbols-outlined" *ngIf="!confirmation">close</div>
                        </ng-container>
                    </td>
                    <td>{{getOrderProductionDays(order)}}</td>
                    <td>{{getOrderTotalDeliveryDays(order)}}</td>
                    <td>
                        <ng-container *ngIf="order.shippingDispatches">
                            <ng-container *ngFor="let dispatch of order.shippingDispatches">
                                <a href="{{dispatch.trackingUrl}}" target="_blank"><span
                                        [ngClass]="{'delivered': dispatch.delivered, 'returned': dispatch.returned}"
                                        class="material-symbols-outlined partner-color shipping-icon">local_shipping</span></a>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <button mat-raised-button color="primary" (click)="markOrderAsDelivered(order)">{{ 'Levererad' | translate }}</button>
                    </td>
                </tr>
            </table>
        </div>
        <div *ngIf="!ordersWithDeliveryIssues">
            <h2>{{ 'Inga leveransproblem upptäcktes.' | translate }}</h2>
        </div>
        <br />
        <hr />
        <br />
    </div>
    <br />
    <div *ngIf="skusWithoutPrices && skusWithoutPrices.length">
        <h2>{{ 'Ej prissatta SKUer' | translate }}</h2>
        <div>
            <table class="fullwidth styled">
                <tr *ngFor="let sku of skusWithoutPrices">
                    <td>{{sku}}</td>
                </tr>
            </table>
        </div>
    </div>

    <div *ngIf="skusWithoutPrices && !skusWithoutPrices.length">
        <h2>{{ 'Alla SKUer är prissatta.' | translate }}</h2>
    </div>
    <br />
    <br />
</div>